<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box">
      <button-a class="goBackBtn" color="#707070" bgcolor="transparent" @click.native="$router.go(-1)">
        <i class="el-icon-back"></i> 返回
      </button-a>
    </div>

    <div class="block white_box">
          <h2 class="font_18_black">系统最近更新</h2>
      <el-timeline>
        <el-timeline-item v-for="(item, key) in data" :key="key" :timestamp="date(item.nodeTime) + ' ' + item.versionNumber" placement="top">
          <el-card>
            <h4 class="font_14_black">{{item.title}}</h4>
            <div class="content font_14_gray">
              <div v-html="item.content"></div>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { dateConvert } from "@/js/tool.js";

export default {
  components: {},
  props: {},
  data() {
    return {
        data: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    getData() {
      Get("api/v1/version-nodes/timeline").then(res => {
        this.data = res.data;
      });
    },
    // 日期转换
    date(date) {
      return dateConvert(date, {
          format: "Y/M/D"
      });
    },
  },
  created() {},
  mounted() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 32px;
  h2 {
    margin: 0 0 20px;
    line-height: 1;
  }
  .block {
    padding: 55px 30px;
    .el-card {
      padding: 10px 20px 4px;
    }
    h4 {
      margin: 0 0 10px;
    }
    .content {
        line-height: 30px;
    }
  }
  .back-btn-box {
    margin-bottom: 32px;
  }
  .goBackBtn {
    font-size: 16px !important;
    border: none !important;
    border-color: transparent !important;
  }
}
</style>